import '@fontsource-variable/inter';
import '@fontsource-variable/archivo';
import './styles/index.css';
import './shared/i18n';

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './app/App';
import { installAuthBridge } from './features/auth';

// Klient HTTP musi znac sesje, zanim poleci pierwsze zadanie.
installAuthBridge();

const container = document.getElementById('root');
if (!container) {
  throw new Error('Nie znaleziono elementu #root w dokumencie.');
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
